/** Normalized API error. Every backend error uses {"error": {code, message, fields}}. */
export class ApiError extends Error {
  readonly status: number;
  readonly code: string;
  readonly fields: Record<string, string[]>;

  constructor(status: number, code: string, message: string, fields: Record<string, string[]> = {}) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.code = code;
    this.fields = fields;
  }

  fieldError(name: string): string | undefined {
    return this.fields[name]?.[0];
  }
}

type ErrorBody = { error?: { code?: string; message?: string; fields?: Record<string, unknown> } };

export function toApiError(status: number, body: unknown): ApiError {
  const err = (body as ErrorBody | undefined)?.error;
  const fields: Record<string, string[]> = {};
  for (const [key, value] of Object.entries(err?.fields ?? {})) {
    fields[key] = Array.isArray(value) ? value.map(String) : [String(value)];
  }
  const fallback =
    status === 0
      ? "K-SHOP is unreachable. Check your connection and try again."
      : status >= 500
        ? "Something went wrong on our side. Please try again."
        : "The request could not be completed.";
  return new ApiError(status, err?.code ?? (status === 0 ? "network_error" : "error"), err?.message || fallback, fields);
}

export function errorMessage(error: unknown): string {
  if (error instanceof ApiError) return error.message;
  if (error instanceof Error) return error.message;
  return "Something went wrong.";
}
